module.exports = __webpack_public_path__ + "static/media/dot_net_logo.99a76f20.png";